
import axios from 'axios';
import config from '../config';




export const medicalInfoService = {
    getByPerson,
    getById,
    save
};

function getByPerson() {

    const url = `${config.service}/services/medical-info`;
    let token = localStorage.getItem('accessToken');
    console.log(token);
    axios.defaults.headers.common['x-access-token'] = token;
    return axios.get(url);
}

function getById(id) {
    const url = `${config.askmedApiHost}/medicalinfo/${id}`;
    axios.defaults.headers.common['x-access-token'] = config.askmedSecret;

    return axios.get(url);
}

function save(medicalInfoObj) {
    const url = `${config.askmedApiHost}/medicalinfo/`;

    axios.defaults.headers.common['x-access-token'] = config.askmedSecret;

    return axios.post(url, medicalInfoObj);
}